import React from 'react';

const Consulting = () => {
    return (
        <div>
          <section id="page-title" className="page-title page-title-layout10 bg-overlay bg-parallax text-center">
            <div className="bg-img"><img src="assets/images/page-titles/bainstorm.jpg" alt="background" /></div>
            <div className="container">
              <div className="row">
                <div className="col-sm-12 col-md-12 col-lg-8 offset-lg-2">
                  <h1 className="pagetitle__heading">Consulting Services</h1>
                  <nav aria-label="breadcrumb">
                    <ol className="breadcrumb justify-content-center">
                      <li className="breadcrumb-item"><a href="consulting#">Home</a></li>
                      <li className="breadcrumb-item active" aria-current="page">Consulting Services</li>
                    </ol>
                  </nav>
                </div>{/* /.col-lg-8 */}
              </div>{/* /.row */}
            </div>{/* /.container */}
          </section>{/* /.page-title */}
          {/* =========================== 
        portfolio Grid 
      ============================= */}
          <section id="portfolioGrid" className="portfolio portfolio-grid">
            <div className="container">
              <div className="row">
                {/* portfolio item #1 */}
                <div className="col-sm-6 col-md-6 col-lg-4">
                  <div className="portfolio-item">
                    <div className="portfolio__img">
                      <img src="assets/images/case-studies/planning.jpg" alt="portfolio img" />
                    </div>{/* /.portfolio-img */}
                    <div className="portfolio__content">
                      <h4 className="portfolio__title"><a href="consulting#">Facility Design &amp; Planning</a></h4>
                      <div className="divider__line divider__lg" />
                      <p className="portfolio__desc" style={{color: '#000'}}>
                      </p><div className="footer__widget footer__widget-nav">
                        <h6 className="footer__widget-title" style={{color: '#000'}}>Facility design review with respect to:</h6>
                        <div className="footer__widget-content">
                          <nav>
                            <ul className="list-unstyled">
                              <li><a href="consulting#" style={{color: '#000', fontSize: '16px'}}>Soft services delivery</a></li>
                              <li><a href="consulting#" style={{color: '#000', fontSize: '16px'}}>Security</a></li>
                              <li><a href="consulting#" style={{color: '#000', fontSize: '16px'}}>Fire &amp; life safety</a></li>
                              <li><a href="consulting#" style={{color: '#000', fontSize: '16px'}}>Energy efficiency</a></li>
                              <li><a href="consulting#" style={{color: '#000', fontSize: '16px'}}>Environmental aspects</a></li>
                              <li><a href="consulting#" style={{color: '#000', fontSize: '16px'}}>Building management systems</a></li>
                            </ul>
                          </nav>
                        </div>{/* /.footer-widget-content */}
                        <h6 className="footer__widget-title" style={{color: '#000'}}>Facilities management master planning</h6>
                        <h6 className="footer__widget-title" style={{color: '#000'}}>Risk reviews</h6>
                        <h6 className="footer__widget-title" style={{color: '#000'}}>Life cycle modeling</h6>
                      </div>{/* /.col-xl-2 */}
                      <p />
                    </div>{/* /.portfolio-content */}
                  </div>{/* /.portfolio-item */}
                </div>{/* /.col-lg-4 */}
                {/* portfolio item #2 */}
                <div className="col-sm-6 col-md-6 col-lg-4">
                  <div className="portfolio-item">
                    <div className="portfolio__img">
                      <img src="assets/images/case-studies/facilitymgt.jpg" alt="portfolio img" />
                    </div>{/* /.portfolio-img */}
                    <div className="portfolio__content">
                      <h4 className="portfolio__title"><a href="consulting#">Facility Systems</a></h4>
                      <div className="divider__line divider__lg" />
                      <div className="footer__widget footer__widget-nav">
                        <div className="footer__widget-content">
                          <nav>
                            <ul className="list-unstyled">
                              <li><a href="consulting#" style={{color: '#000', fontSize: '16px'}}>Business Case Development</a></li>
                              <li><a href="consulting#" style={{color: '#000', fontSize: '16px'}}>System Requirement Need Analysis</a></li>
                              <li><a href="consulting#" style={{color: '#000', fontSize: '16px'}}>RFP Preparation</a></li>
                              <li><a href="consulting#" style={{color: '#000', fontSize: '16px'}}>System Evaluation</a></li>
                              <li><a href="consulting#" style={{color: '#000', fontSize: '16px'}}>Vendor Selection</a></li>
                              <li><a href="consulting#" style={{color: '#000', fontSize: '16px'}}>Program Management</a></li>
                              <li><a href="consulting#" style={{color: '#000', fontSize: '16px'}}>Post Implementation Testing Supervision</a></li>
                            </ul>
                          </nav>
                        </div>{/* /.footer-widget-content */}
                      </div>{/* /.col-xl-2 */}
                    </div>{/* /.portfolio-content */}
                  </div>{/* /.portfolio-item */}
                </div>{/* /.col-lg-4 */}
                <div className="col-sm-6 col-md-6 col-lg-4">
                  <div className="portfolio-item">
                    <div className="portfolio__img">
                      <img src="assets/images/case-studies/transition.jpg" alt="portfolio img" />
                    </div>{/* /.portfolio-img */}
                    <div className="portfolio__content">
                      <h4 className="portfolio__title"><a href="consulting#">Transition &amp; Operations Planning</a></h4>
                      <div className="divider__line divider__lg" />
                      <div className="footer__widget footer__widget-nav">
                        <h6 className="footer__widget-title" style={{color: '#000'}}>Transition Planning Which Include</h6>
                        <div className="footer__widget-content">
                          <nav>
                            <ul className="list-unstyled">
                              <li><a href="consulting#" style={{color: '#000', fontSize: '16px'}}>Facility Handover Process</a></li>
                              <li><a href="consulting#" style={{color: '#000', fontSize: '16px'}}>Operational Model Development</a></li>
                              <li><a href="consulting#" style={{color: '#000', fontSize: '16px'}}>Supplier Selection</a></li>
                              <li><a href="consulting#" style={{color: '#000', fontSize: '16px'}}>Contract Novations</a></li>
                              <li><a href="consulting#" style={{color: '#000', fontSize: '16px'}}>Supply Chain Model</a></li>
                              <li><a href="consulting#" style={{color: '#000', fontSize: '16px'}}>Service level Agreement Preparation</a></li>
                              <li><a href="consulting#" style={{color: '#000', fontSize: '16px'}}>HSE polices and procedures</a></li>
                              <li><a href="consulting#" style={{color: '#000', fontSize: '16px'}}>Maintenance Planning</a></li>
                            </ul>
                          </nav>
                        </div>{/* /.footer-widget-content */}
                        <h6 className="footer__widget-title" style={{color: '#000'}}>Facilities management master planning</h6>
                        <h6 className="footer__widget-title" style={{color: '#000'}}>Risk reviews</h6>
                        <h6 className="footer__widget-title" style={{color: '#000'}}>Life cycle modeling</h6>
                      </div>{/* /.col-xl-2 */}
                    </div>{/* /.portfolio-content */}
                  </div>{/* /.portfolio-item */}
                </div>{/* /.col-lg-4 */}
                {/* portfolio item #3 */}
                <div className="col-sm-6 col-md-6 col-lg-2">
                </div>
                {/* /.col-lg-4 */}
                {/* portfolio item #4 */}
              </div>{/* /.row */}
            </div>{/* /.container */}
          </section>
        </div>
      );
};

export default Consulting;
